export default __webpack_public_path__ + "static/media/warning--skewed-t-roads-right--g3.544ec832.png";